function cov_jmnwxbpu8() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Invite.tsx";
  var hash = "6fb5b95ec0dcc8cf57907448d7ef39b94f960d57";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Invite.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6fb5b95ec0dcc8cf57907448d7ef39b94f960d57"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_jmnwxbpu8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_jmnwxbpu8();
var Icon = (cov_jmnwxbpu8().s[0]++, {
  name: 'invite',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.9944 15.2515C19.1944 15.4576 19.4444 15.5606 19.7444 15.5606C20.0444 15.5606 20.2944 15.4576 20.4944 15.2515C20.6944 15.0455 20.7944 14.7879 20.7944 14.4788V12.5212H22.6944C22.9944 12.5212 23.2444 12.4182 23.4444 12.2121C23.6444 12.0061 23.7444 11.7485 23.7444 11.4394C23.7444 11.1303 23.6444 10.8727 23.4444 10.6667C23.2444 10.4606 22.9944 10.3576 22.6944 10.3576H20.7944V8.4C20.7944 8.09091 20.6944 7.83333 20.4944 7.62727C20.2944 7.42121 20.0444 7.31818 19.7444 7.31818C19.4444 7.31818 19.1944 7.42121 18.9944 7.62727C18.7944 7.83333 18.6944 8.09091 18.6944 8.4V10.3576H16.7944C16.4944 10.3576 16.2444 10.4606 16.0444 10.6667C15.8444 10.8727 15.7444 11.1303 15.7444 11.4394C15.7444 11.7485 15.8444 12.0061 16.0444 12.2121C16.2444 12.4182 16.4944 12.5212 16.7944 12.5212H18.6944V14.4788C18.6944 14.7879 18.7944 15.0455 18.9944 15.2515ZM6.65642 12.379C7.48176 13.2294 8.46942 13.6545 9.61942 13.6545C10.7861 13.6545 11.7818 13.2294 12.6064 12.379C13.4318 11.5294 13.8444 10.5121 13.8444 9.32727C13.8444 8.12525 13.4318 7.10354 12.6064 6.26212C11.7818 5.42071 10.7861 5 9.61942 5C8.46942 5 7.48176 5.42071 6.65642 6.26212C5.83176 7.10354 5.41942 8.12525 5.41942 9.32727C5.41942 10.5121 5.83176 11.5294 6.65642 12.379ZM10.9944 10.7305C10.6111 11.1173 10.1528 11.3106 9.61942 11.3106C9.10276 11.3106 8.65276 11.1173 8.26942 10.7305C7.88609 10.3445 7.69442 9.87677 7.69442 9.32727C7.69442 8.77778 7.88609 8.30968 8.26942 7.92297C8.65276 7.53695 9.10276 7.34394 9.61942 7.34394C10.1528 7.34394 10.6111 7.53695 10.9944 7.92297C11.3778 8.30968 11.5694 8.77778 11.5694 9.32727C11.5694 9.87677 11.3778 10.3445 10.9944 10.7305ZM8.08614 17.3636H11.7528C12.9668 17.3636 14.0942 18.0119 14.7316 19.0764L14.9398 19.4242H4.89909L5.10733 19.0764C5.74474 18.0119 6.87208 17.3636 8.08614 17.3636ZM2.97961 17.7241C4.07231 15.8991 6.0049 14.7879 8.08614 14.7879H11.7528C13.834 14.7879 15.7666 15.8991 16.8593 17.7241L17.5379 18.8575C18.3599 20.2304 17.4014 22 15.8358 22H4.00316C2.43755 22 1.479 20.2304 2.30099 18.8575L2.97961 17.7241Z\" fill=\"currentColor\"/>"
});
export default Icon;